// Title-case a finished string (used as a save-time safety pass).
export const toPascalCase = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str.trim().split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
};

// Live-typing variant: preserves a single trailing space so the user can keep typing.
export const normaliseText = (val) => {
  if (!val) return '';
  const trailingSpace = val.endsWith(' ') ? ' ' : '';
  const words = val.trimStart().split(/\s+/).filter(Boolean);
  return words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') + trailingSpace;
};

export const SIDES = ['Common', 'Groom', 'Bride'];
export const EVENT_TYPES = [
  'Birthday Party', 'Marriage', 'Engagement', 'Anniversary', 'Corporate Event',
  'Thread Ceremony', 'Cocktail Party', 'Reception', 'Naming Ceremony',
  'Housewarming', 'Baby Shower', 'Other',
];
// Sub-events ("functions") that make up one event.
export const FUNCTION_TYPES = [
  'Opening / Welcome', 'Main Celebration', 'Dinner', 'Reception', 'Cocktail Party',
  'Cake Cutting', 'Games', 'Return Gifts', 'Haldi', 'Mehndi', 'Sangeet',
  'Wedding', 'Wedding Cum Reception', 'Ring Ceremony', 'Conference', 'Awards', 'Other',
];
export const isMarriageEventType = (value) => {
  const type = String(value || '').trim().toLowerCase();
  return type === 'marriage' || type === 'wedding';
};
// Member invite lifecycle (the "mark" statuses).
export const INVITE_STATUSES = ['Pending', 'Invited', 'Confirmed', 'Declined'];
// Who can see a guest a member added: Common = all members, Private = only the adder.
export const VISIBILITIES = ['Private', 'Common'];
export const visibilityChipClass = (v) => (v === 'Common' ? 'chip ok' : 'chip pend');
export const inviteChipClass = (s) =>
  s === 'Confirmed' ? 'chip ok' : s === 'Declined' ? 'chip danger'
    : s === 'Invited' ? 'chip warn' : 'chip pend';

export const sideChipClass = (side) =>
  side === 'Groom' || side === 'Male' ? 'chip male' : side === 'Bride' || side === 'Female' ? 'chip female' : 'chip common';

// Full display name from Surname + (first) Name + Father/Husband parts.
// `nameKey` is the first-name column ('GuestName' for guests, 'MemberName' for party).
export const fullName = (row, nameKey = 'GuestName') =>
  [row.Surname, row[nameKey], row.FatherHusband].map(x => (x || '').trim()).filter(Boolean).join(' ')
  || (row[nameKey] || '').trim() || '—';

// ── Date display / form helpers (API gives 'YYYY-MM-DD' / 'YYYY-MM-DD HH:MM:SS') ─
export const fmtDate = (v) => {
  if (!v) return '—';
  const d = String(v).slice(0, 10).split('-');
  return d.length === 3 ? `${d[2]}-${d[1]}-${d[0]}` : String(v);
};
export const fmtDateTime = (v) => {
  if (!v) return '—';
  const s = String(v);
  const datePart = fmtDate(s);
  const time = s.length >= 16 ? s.slice(11, 16) : '';
  return time ? `${datePart} ${time}` : datePart;
};
// 'YYYY-MM-DD HH:MM:SS' → 'YYYY-MM-DDTHH:MM' for <input type=datetime-local>
export const toDatetimeLocal = (v) => (v ? String(v).replace(' ', 'T').slice(0, 16) : '');
// 'YYYY-MM-DDTHH:MM' → 'YYYY-MM-DD HH:MM:00' for MySQL
export const fromDatetimeLocal = (v) => {
  if (!v) return null;
  const s = String(v).replace('T', ' ');
  return s.length === 16 ? `${s}:00` : s;
};
export const money = (n) => '₹' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
